import { useCallback } from 'react';
import { createCategory } from 'actions/expenses';
import { getCategories } from 'actions/user';
import { getBudgets } from 'features/budgeting/actions';
import { useRequiredBenefitCallbackWithSpaces } from 'features/premium/hooks/useRequiredBenefitCallback';
import { muteErrorAndResult, useFetchOld } from 'hooks';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import Amplitude from 'utils/amplitude';
export function useCreateCustomCategory(onSuccess) {
    const currency = useAppSelector((store) => store.user.user.currency);
    const dispatch = useAppDispatch();
    const [, , isFetching, fetch] = useFetchOld(muteErrorAndResult);
    const createCustomCategory = useRequiredBenefitCallbackWithSpaces(useCallback(async (category) => {
        const { displayName, color, emoji, parentCategoryId } = category;
        const response = await fetch(createCategory({ displayName, color, emoji, parentCategoryId }, currency));
        if (!response)
            return;
        dispatch(getCategories());
        dispatch(getBudgets());
        Amplitude.logEvent('Premium.CustomCategoryCreated');
        onSuccess();
    }, [currency, onSuccess]), 'customCategories');
    return [isFetching, createCustomCategory];
}
